import { render, staticRenderFns } from "./StoreInputField.vue?vue&type=template&id=3afe3240&scoped=true&"
import script from "./StoreInputField.vue?vue&type=script&lang=js&"
export * from "./StoreInputField.vue?vue&type=script&lang=js&"
import style0 from "./StoreInputField.vue?vue&type=style&index=0&id=3afe3240&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe3240",
  null
  
)

export default component.exports